import React, { useState } from "react";

// Images
import article1Img from "../assets/article_image/article1.jpg";
import article2Img from "../assets/article_image/article2.jpg";
import article3Img from "../assets/article_image/article3.jpg";
import article4Img from "../assets/article_image/article4.jpg";
import article5Img from "../assets/article_image/article5.jpg";
import article6Img from "../assets/article_image/article6.jpg";
import article7Img from "../assets/article_image/article7.jpg";
// PDFs
import pdf1 from "../assets/article_pdf/Birth_Control_and_Periods.pdf";
import pdf2 from "../assets/article_pdf/DecodeyourcycleTheBlueprint101.pdf";
import pdf3 from "../assets/article_pdf/PadstoBody.pdf";
import pdf4 from "../assets/article_pdf/Period_Sex.pdf";
import pdf5 from "../assets/article_pdf/VaginaDischargeFears102.pdf";
import pdf6 from "../assets/article_pdf/VaginaDischargeMyths101.pdf";
import pdf7 from "../assets/article_pdf/VulvaMyths.pdf";

const articles = [
   {
    id: 2,
    image: article2Img,
    pdf: pdf2,
    title: "Decode Your Cycle",
  },
  {
    id: 1,
    image: article1Img,
    pdf: pdf1,
    title: "Birth Control and Periods",
  },
 
  {
    id: 3,
    image: article3Img,
    pdf: pdf3,
    title: "Pads to Body",
  },
  {
    id: 4,
    image: article4Img,
    pdf: pdf4,
    title: "Period Sex 101",
  },
  {
    id: 5,
    image: article5Img,
    pdf: pdf5,
    title: "Vagina Discharge Fears",
  },
  {
    id: 6,
    image: article6Img,
    pdf: pdf6,
    title: "Vagina Discharge Myths",
  },
  {
    id: 7,
    image: article7Img,
    pdf: pdf7,
    title: "Vulva Myths",
  },
];

function ArticleCard({ article, onSelect }) {
  return (
    <div className="group relative w-56 h-80 rounded-2xl overflow-hidden shadow-lg bg-white cursor-pointer">
      {/* Image */}
      <img
        src={article.image}
        alt={article.title}
        className="w-full h-full object-cover"
      />

      {/* Hover Overlay */}
      <div
        className="
          absolute inset-0
          bg-black/70
          opacity-0
          group-hover:opacity-100
          transition-all duration-300
          flex flex-col
          items-center
          justify-center
          text-center
          p-4
        "
      >
        <h3 className="text-white font-bold text-xl mb-4">{article.title}</h3>

        <button
          onClick={() => onSelect(article.pdf)}
          className="
            bg-[#ff4f6d]
            hover:bg-[#ff3558]
            text-white
            px-5
            py-2
            rounded-lg
            font-semibold
            shadow-lg
          "
        >
          View PDF
        </button>
      </div>
    </div>
  );
}

function Articles() {
  const [selectedPdf, setSelectedPdf] = useState(null);

  return (
    <div className="min-h-screen bg-[#FFF0F3] p-6 pb-20">
      {/* Heading */}
      <div className="text-center mb-14">
        <h1
          className="text-4xl md:text-4xl font-black uppercase"
          style={{
            color: "#5A0018",
            // textShadow: "3px 3px 0px #C89AAC",
          }}
        >
          OUR ARTICLES
        </h1>

        <p className="mt-4 text-sm md:text-base tracking-[6px] uppercase text-[#C89AAC] font-semibold">
          DISCOVER INSIGHTS FOR BETTER HEALTH
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-3 gap-y-6 justify-items-center max-w-5xl mx-auto">
        {articles.map((article) => (
          <ArticleCard
            key={article.id}
            article={article}
            onSelect={setSelectedPdf}
          />
        ))}
      </div>

      {/* PDF Modal */}
      {selectedPdf && (
        <div
          className="fixed inset-0 bg-black/70 flex items-center justify-center z-[9999] p-4"
          onClick={() => setSelectedPdf(null)}
        >
          <div
            className="relative bg-white w-[95vw] h-[95vh] rounded-2xl shadow-2xl overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setSelectedPdf(null)}
              className="
                absolute
                top-4
                right-4
                z-50
                w-11
                h-11
                rounded-full
                bg-white
                shadow-lg
                text-2xl
                font-bold
                text-gray-700
                hover:bg-red-500
                hover:text-white
                transition
              "
            >
              ×
            </button>

            {/* PDF Viewer */}
            {/* <iframe
              src={selectedPdf}
              title="PDF Viewer"
              className="w-full h-full border-0"
            /> */}
            {/* PDF Viewer */}
<object
  data={selectedPdf}
  type="application/pdf"
  className="w-full h-full border-0"
>
  {/* Fallback for browsers that can't display the PDF (like mobile) */}
  <div className="flex flex-col items-center justify-center h-full p-6 text-center">
    <p className="text-gray-600 mb-4">Your browser doesn't support viewing PDFs directly.</p>
    <a
      href={selectedPdf}
      download
      className="bg-[#ff4f6d] text-white px-6 py-2 rounded-lg font-bold"
    >
      Download to View
    </a>
  </div>
</object>
          </div>
        </div>
      )}
    </div>
  );
}

export default Articles;
